import { api as api_v2 } from '@/api/api.v2';
import api from '@/api/api';

export const wellResearchFilterReportModel = {
    name: 'wellResearchFilterReport',
    state: {
        selectedTab: {},
        selectedResearch: {},
        selectedIntervalResearch: {},
        isLoadingResearch: false,
        isErrorResearch: false,
        gridApiTabDrilling: null,
        gridApiTabDevelopment: null,
        isChildrenReady: {},
        reportData: {},
    },
    reducers: {
        setSelectedResearch(state, payload) {
            const { wellId, research } = payload;
            return {
                ...state,
                selectedResearch: {
                    ...state.selectedResearch,
                    [wellId]: research,
                },
            };
        },

        setSelectedIntervalResearch(state, payload) {
            const { wellId, selectedIntervalResearch } = payload;
            return {
                ...state,
                selectedIntervalResearch: {
                    ...state.selectedIntervalResearch,
                    [wellId]: selectedIntervalResearch,
                },
            };
        },
        startRequest(state) {
            return { ...state, isLoadingResearch: true, isErrorResearch: false };
        },
        stopRequest(state) {
            return { ...state, isLoadingResearch: false, isErrorResearch: false };
        },
        setError(state) {
            return { ...state, isLoadingResearch: false, isErrorResearch: true };
        },

        setSelectedTab(state, payload) {
            const { wellId, selectedTab } = payload;
            return {
                ...state,
                selectedTab: {
                    ...state.selectedTab,
                    [wellId]: selectedTab,
                },
            };
        },

        setGridApiTabDrilling(state, payload) {
            const { wellId, gridApi } = payload;

            return {
                ...state,
                gridApiTabDrilling: {
                    ...state.gridApiTabDrilling,
                    [wellId]: gridApi,
                },
            };
        },

        setGridApiTabDevelopment(state, payload) {
            const { wellId, gridApi } = payload;
            return {
                ...state,
                gridApiTabDevelopment: {
                    ...state.gridApiTabDevelopment,
                    [wellId]: gridApi,
                },
            };
        },
        setChildrenReady(state, payload) {
            const { isChildrenReady, wellId } = payload;
            return {
                ...state,
                isChildrenReady: {
                    ...state.isChildrenReady,
                    [wellId]: isChildrenReady,
                },
            };
        },
        resetChildrenReady(state, payload) {
            const { wellId } = payload;
            return {
                ...state,
                isChildrenReady: {
                    ...state.isChildrenReady,
                    [wellId]: false,
                },
            };
        },
        resetState(state) {
            state = {
                selectedTab: 'drilling',
                selectedResearch: {},
                selectedIntervalResearch: {},
                isLoadingResearch: false,
                isErrorResearch: false,
                gridApiTabDrilling: null,
                gridApiTabDevelopment: null,
                isChildrenReady: false,
            };
            return state;
        },
        updateReportData(state, payload) {
            const { reportData } = state;
            const { data, wellId, key } = payload;
            return {
                ...state,
                reportData: {
                    ...reportData,
                    [wellId]: {
                        ...reportData[wellId],
                        [key]: data,
                    },
                },
            };
        },
        setReportData(state, payload) {
            const { reportData } = state;
            const { data, wellId } = payload;

            return {
                ...state,
                reportData: {
                    ...reportData,
                    [wellId]: data,
                },
            };
        },
    },
    effects: dispatch => ({
        async fetchWellResearch(payload) {
            const {
                startRequest,
                setError,

                stopRequest,
                setChildrenReady,

                setReportData,
            } = dispatch.wellResearchFilterReport;

            startRequest();
            try {
                const result = await api_v2.reports.fetchWellResearchInfoReport({ wellId: payload });
                const curves = await api.carottage.fetchResearch(payload);
                setReportData({
                    data: {
                        ...result,
                        curves,
                    },
                    wellId: payload,
                });
                setChildrenReady({ wellId: payload, isChildrenReady: true });
                stopRequest();
            } catch (error) {
                console.error('Ошибка на сервере: ', error);
                setError('Не удалось загрузить отчет. Ошибка на сервере.');
                console.log('%c well researches error', 'color: red;', error);
                setError();
            }
        },
    }),
};
